import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./home/home.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HttpClientModule } from "@angular/common/http";
import { GmonDialogComponent } from "./gmon-dialog/gmon-dialog.component";
import { GMonService } from "./_services/gmon-service/gmon.service";
import { MapService } from "./_services/map/map.service";
import { NodeDetailsDialogComponent } from "./node-details-dialog/node-details-dialog.component";
import { NgxSpinnerModule } from "ngx-spinner";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { ChartModule } from "angular2-highcharts";
import { CableDetailsDialogComponent } from "./cable-details-dialog/cable-details-dialog.component";
// import { HighchartsStatic } from "angular2-highcharts/dist/HighchartsService";
import { BasicAlertComponent } from "./_commons/basic-alert/basic-alert.component";
import { BasicDialogComponent } from "./_commons/basic-dialog/basic-dialog.component";
import { ApplicationService } from "./_services/application/application.service";
// import { AngularDateTimePickerModule } from "angular2-datetimepicker";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DateUtils } from "./_commons/date-utils";
import { LoginComponent } from './login/login.component';
import { HttpCustomInterceptor } from './_interceptors/http.interceptor';
import { LcDialogDetailsComponent } from "./lc-dialog-details/lc-dialog-details.component";
import { LcDialogComponent } from "./lc-dialog/lc-dialog.component";
import { LaDialogComponent } from "./la-dialog/la-dialog.component";
import { NotificationsDialogComponent } from "./notifications-dialog/notifications-dialog.component";
import { NoDataComponent } from "./_commons/no-data/no-data.component";
// import ngx-translate and the http loader
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./_services/configuration/configuration.service";
import { ReactivePowerAnalysisDialogComponent } from './reactive-power-analysis-dialog/reactive-power-analysis-dialog.component';
import { ReactivePowerAnalysisService } from './_services/reactive-power-analysis-service/reactive-power-analysis.service';
import { GplanDialogComponent } from './gplan-dialog/gplan-dialog.component';
import { StatisticDialogComponentComponent } from './statistic-dialog-component/statistic-dialog-component.component';
import { NgSelectModule } from "@ng-select/ng-select";
import { SpinnerInterceptor } from "./_interceptors/spinner-interceptor";
import { MapViewDialogComponent } from './gplan-dialog/map-view-dialog/map-view-dialog.component';
import { BasicConfirmationComponent } from "./_commons/basic-confirmation/basic-confirmation.component";
import { NgToggleModule } from 'ng-toggle-button';
import { PvListProcessingComponent } from './pv-list-processing/pv-list-processing.component';
import { MeheStatsDialogComponent } from './mehe-stats-dialog/mehe-stats-dialog.component';
import { LiveMonitoringAndControlComponent } from './live-monitoring-and-control/live-monitoring-and-control.component';
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatTableModule } from "@angular/material/table";
import { GplanSummaryTableComponent } from './gplan-summary-table/gplan-summary-table.component';
import { BasicDialogComponentRefresh } from "./_commons/basic-dialog/basic-diolog-refresh.component";
import { ShortCircuitCurrentAnalysisComponent } from './short-circuit-current-analysis/short-circuit-current-analysis.component';
import { ThdMonitoringComponent } from './thd-monitoring/thd-monitoring.component';
import { InitialNotificationsComponent } from './initial-notifications/initial-notifications.component';
import { ApplicationsSummaryTablesComponent } from './applications-summary-tables/applications-summary-tables.component';
import { PortalModule } from "@angular/cdk/portal";
import { MatSortModule } from "@angular/material/sort";
import { GmonOverviewComponent } from './applications-summary-tables/gmon-overview/gmon-overview.component';
import { LaOverviewComponent } from './applications-summary-tables/la-overview/la-overview.component';
import { PlanningOverviewComponent } from './applications-summary-tables/planning-overview/planning-overview.component';
import { GmonPlanningComponent } from './applications-summary-tables/gmon-planning/gmon-planning.component';
import { LaPlanningComponent } from './applications-summary-tables/la-planning/la-planning.component';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { AlarmsMenuComponent } from './applications-summary-tables/alarms-menu/alarms-menu.component';
import { HighchartsChartModule } from 'highcharts-angular';




// const modChecks: Array<[string, any]> = [
//   ['NgSelectModule', NgSelectModule],
//   ['NgToggleModule', NgToggleModule],
//   ['NgbModule', NgbModule],
//   ['NgxSpinnerModule', NgxSpinnerModule],
//   // ['AngularDateTimePickerModule', AngularDateTimePickerModule],
//   ['MatSnackBarModule', MatSnackBarModule],
//   ['MatSlideToggleModule', MatSlideToggleModule],
//   ['PortalModule', PortalModule],
//   ['MatTableModule', MatTableModule],
//   ['MatSortModule', MatSortModule],
//   ['MatPaginatorModule', MatPaginatorModule],
// ];

// modChecks.forEach(([name, mod]) => {
//   console.log(`${name} exists:`, !!mod, 'ɵmod exists:', !!(mod as any)?.ɵmod);
// });



export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

declare var require: any;

export function highchartsFactory() {
  const hc = require("highcharts/highstock");
  const hm = require("highcharts/highcharts-more");
  const mr = require("highcharts/modules/solid-gauge");
  mr(hc);
  hm(hc);
  return hc;
}
export function initConfig(configurationService: ConfigurationService) {
  return () => configurationService.loadConfigurations();
}

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    GmonDialogComponent,
    NodeDetailsDialogComponent,
    CableDetailsDialogComponent,
    BasicAlertComponent,
    BasicDialogComponent,
    BasicDialogComponentRefresh,
    BasicConfirmationComponent,
    LcDialogDetailsComponent,
    LcDialogComponent,
    LaDialogComponent,
    NotificationsDialogComponent,
    NoDataComponent,
    LoginComponent,
    ReactivePowerAnalysisDialogComponent,
    GplanDialogComponent,
    StatisticDialogComponentComponent,
    MapViewDialogComponent,
    PvListProcessingComponent,
    MeheStatsDialogComponent,
    LiveMonitoringAndControlComponent,
    GplanSummaryTableComponent,
    ShortCircuitCurrentAnalysisComponent,
    ThdMonitoringComponent,
    InitialNotificationsComponent,
    ApplicationsSummaryTablesComponent,
    GmonOverviewComponent,
    LaOverviewComponent,
    PlanningOverviewComponent,
    GmonPlanningComponent,
    LaPlanningComponent,
    LaOverviewComponent,
    AlarmsMenuComponent
  ],
  imports: [
    NgSelectModule,
    NgToggleModule,
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    MatSnackBarModule,
    AppRoutingModule,
    HttpClientModule,
    NgbModule,
    NgxSpinnerModule,
    HighchartsChartModule,
    // ChartModule,
    FormsModule,
    ReactiveFormsModule,
    // AngularDateTimePickerModule,
    MatSlideToggleModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    PortalModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    CommonModule
  ],
  providers: [
    GMonService,
    MapService,
    ApplicationService,
    ReactivePowerAnalysisService,
    DateUtils,
    // {
    //   provide: HighchartsStatic,
    //   useFactory: highchartsFactory
    // },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpCustomInterceptor,
      multi: true
      // useFactory: highchartsFactory
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initConfig,
      deps: [ConfigurationService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  entryComponents: [
    BasicDialogComponent,
    BasicDialogComponentRefresh,
    BasicAlertComponent,
    BasicConfirmationComponent,
    GmonDialogComponent,
    NodeDetailsDialogComponent,
    StatisticDialogComponentComponent,
    CableDetailsDialogComponent,
    LcDialogComponent,
    LcDialogDetailsComponent,
    LaDialogComponent,
    NotificationsDialogComponent,
    ReactivePowerAnalysisDialogComponent,
    GplanDialogComponent,
    MapViewDialogComponent,
    PvListProcessingComponent,
    MeheStatsDialogComponent,
    LiveMonitoringAndControlComponent,
    GplanSummaryTableComponent,
    ShortCircuitCurrentAnalysisComponent,
    ThdMonitoringComponent,
    InitialNotificationsComponent,
    ApplicationsSummaryTablesComponent
  ],
})
export class AppModule { }
